/**
 * @generated SignedSource<<bffce3b14ab9fcb354e508cedc936018>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PermissionGroupPageRemoveUserMutation$variables = {
  connections: ReadonlyArray<string>;
  groupId: string;
  userUuid: string;
};
export type PermissionGroupPageRemoveUserMutation$data = {
  readonly setUserGroupEnabled: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly user: {
      readonly id: string;
    } | null;
  } | null;
};
export type PermissionGroupPageRemoveUserMutation = {
  response: PermissionGroupPageRemoveUserMutation$data;
  variables: PermissionGroupPageRemoveUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userUuid"
},
v3 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "groupId",
    "variableName": "groupId"
  },
  {
    "kind": "Variable",
    "name": "userUuid",
    "variableName": "userUuid"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermissionGroupPageRemoveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SetUserGroupEnabled",
        "kind": "LinkedField",
        "name": "setUserGroupEnabled",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PermissionGroupPageRemoveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SetUserGroupEnabled",
        "kind": "LinkedField",
        "name": "setUserGroupEnabled",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e21a582d1c8f38d06cb853da7b1019b5",
    "id": null,
    "metadata": {},
    "name": "PermissionGroupPageRemoveUserMutation",
    "operationKind": "mutation",
    "text": "mutation PermissionGroupPageRemoveUserMutation(\n  $userUuid: String!\n  $groupId: ID!\n) {\n  setUserGroupEnabled(userUuid: $userUuid, groupId: $groupId, enabled: false) {\n    errors\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "28bdbf058db16ab7644909841ed9e187";

export default node;
